import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { CardTitle } from '~src/spacesPlatform/components/card/CardTitle';
import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';
import { CardPopoverWidget, ContentCard, getContentUrlForItem } from '~src/spacesPlatform/components/card/ContentCard';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { DatabaseTooltip } from '~src/spacesPlatform/components/tooltip/DatabaseTooltip';
import { ContentTooltipProps } from '~src/spacesPlatform/components/tooltip/TooltipHelper';
import { getCommonDatabaseInfo, getGraphQLId, isContentInfoDatabase } from '~src/spacesPlatform/models/CommonDatabaseInfo';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';

import { DatabaseThumbnail } from './DatabaseThumbnail';

export class DatabaseCard extends ContentCard {

    protected getPopoverComponent(): React.ComponentType<ContentTooltipProps> {
        return DatabaseTooltip;
    }

    public render() {
        const { content, urls, allowDragAndDrop, hovered, selected } = this.props;
        const commonDatabase = getCommonDatabaseInfo(content);
        const contentUrl = getDatabaseContentUrl(urls, content);
        return (
            <div className={CardViewStyles.Card}>
                <DatabaseThumbnail
                    allowDragAndDrop={allowDragAndDrop}
                    content={commonDatabase}
                    contentUrl={contentUrl}
                    hovered={hovered}
                    selected={selected}
                    aria-label={content.name}
                    cardZoomPercentage={this.state.cardZoomPercentage}
                />
                <div className={CardViewStyles.ActionRow} style={this.getCardZoomStyleForActionRow()}>
                    <CardTitle name={content.name} data-tb-test-id="database-name" />
                    <span>
                        <CardPopoverWidget
                            content={content}
                            onTriggerClick={this.handleShowPopover}
                            popoverContent={this.renderPopoverContent()}
                            title={Messages.databaseDetails()}
                        />
                    </span>
                    {this.renderActionsMenu()}
                </div>
                {this.shouldRenderExtraInformationAtBottom() && <div className={CardViewStyles.CardDescription}>
                    {this.getDescription()}
                </div>}
            </div>
        );
    }
}

export function getDatabaseContentUrl(urls: SpacesSiteUrls, content: IContentInfo): string {
    if (isContentInfoDatabase(content)) {
        const contentId = getGraphQLId(content);
        return urls.catalogDatabaseUrl(contentId);
    }

    return getContentUrlForItem(content, urls);
}
